import { SupportButton } from "@backstage/core-components";
import {
  EntitySwitch,
  isOrphan,
  EntityOrphanWarning,
  hasCatalogProcessingErrors,
  EntityProcessingErrorsPanel,
  hasRelationWarnings,
  EntityRelationWarning,
} from "@backstage/plugin-catalog";
import { Grid, makeStyles } from "@material-ui/core";
import React from "react";

interface Props {}

const useStyles = makeStyles({
  support: { float: "right" },
});

export const EntityWarningSwitch: React.FC<Props> = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <Grid item xs={12}>
        <div className={classes.support}>
          <SupportButton>All your software catalog entities</SupportButton>
        </div>
      </Grid>

      <EntitySwitch>
        <EntitySwitch.Case if={isOrphan}>
          <Grid item xs={12}>
            <EntityOrphanWarning />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>

      <EntitySwitch>
        <EntitySwitch.Case if={hasCatalogProcessingErrors}>
          <Grid item xs={12}>
            <EntityProcessingErrorsPanel />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>

      <EntitySwitch>
        <EntitySwitch.Case if={hasRelationWarnings}>
          <Grid item xs={12}>
            <EntityRelationWarning />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>
    </>
  );
};
